import { render, staticRenderFns } from "./PayableAging.vue?vue&type=template&id=d2807de2&scoped=true"
import script from "./PayableAging.vue?vue&type=script&lang=js"
export * from "./PayableAging.vue?vue&type=script&lang=js"
import style0 from "./PayableAging.vue?vue&type=style&index=0&id=d2807de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2807de2",
  null
  
)

export default component.exports